import type { BasicRow } from '../SimpleTable'
import type { TableHeaderType } from '../../types'
import HeadlineThree from '../../00-Primitives/Headlines/HeadlineThree'
import SimpleTable from '../SimpleTable'

type Props = {
  data: BasicRow[]
  header?: TableHeaderType[]
  headlineText?: string
  tableStyle?: 'table-striped' | 'table-bordered'
}

function FlexibleTable({
  header,
  headlineText,
  tableStyle = 'table-striped',
  data,
}: Props) {
  const headerVariant = tableStyle === 'table-bordered' ? 'bold' : 'normal'
  const rowVariant = tableStyle === 'table-bordered' ? 'underline' : 'zebra'

  return (
    <div>
      {headlineText && <HeadlineThree>{headlineText}</HeadlineThree>}
      <SimpleTable
        data={data}
        header={header}
        headerVariant={headerVariant}
        rowVariant={rowVariant}
      />
    </div>
  )
}

export default FlexibleTable
